var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

FIGURE.closeMenuWithScroll = function() {
	$(".site-nav a").on("click", (e) => {
		const target = $(e.target).closest("a");
		console.log(target.attr("href"));
		if (target.attr("href").includes("#")) {
			$(".open-nav").trigger("click");
		}
	})
}();